import { FontEntry } from '../../types/font'

export const cinzel: FontEntry = {
  displayName: 'Cinzel',
  weights: {},
  variables: {
    normal: {
      file: 'Cinzel-VariableFont_wght',
      extension: 'ttf',
      format: 'truetype',
      weightRange: [400, 900]
    }
  },
  fallbackMetrics: {
    arial: {
      regular: {
        sizeAdjust: 120.13,
        ascentOverride: 81.24,
        descentOverride: 30.97,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 115.88,
        ascentOverride: 84.22,
        descentOverride: 32.1,
        lineGapOverride: 0
      }
    },
    roboto: {
      regular: {
        sizeAdjust: 121.89,
        ascentOverride: 80.07,
        descentOverride: 30.52,
        lineGapOverride: 0
      },
      bold: {
        sizeAdjust: 122.77,
        ascentOverride: 79.5,
        descentOverride: 30.3,
        lineGapOverride: 0
      }
    }
  }
}
